// src/components/ErrorBoundary.js
// Si un écran plante, on affiche un message et un bouton de rechargement au lieu d'une page vide.
import { Component } from 'react';
import { reportError } from '../utils/errorReporting';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    reportError(error, { componentStack: info?.componentStack });
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div style={{ minHeight: '100vh', background: '#09090b', color: '#e4e4e7', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, fontFamily: 'system-ui, sans-serif' }}>
        <div style={{ maxWidth: 420, textAlign: 'center' }} data-testid="error-boundary">
          <h1 style={{ fontSize: 20, fontWeight: 700, marginBottom: 12 }}>Une erreur est survenue</h1>
          <p style={{ color: '#a1a1aa', fontSize: 14, lineHeight: 1.6, marginBottom: 20 }}>
            Cette page n'a pas pu s'afficher. L'équipe a été prévenue automatiquement. Rechargez la page pour réessayer.
          </p>
          <button onClick={() => window.location.reload()} style={{ background: '#2563eb', color: '#fff', border: 0, padding: '10px 20px', fontSize: 14, cursor: 'pointer' }}>
            Recharger la page
          </button>
        </div>
      </div>
    );
  }
}
